<div class="grid-container grid-3 grid-align-items-center" [formGroup]="formGroup">
    <ui-form-field [label]="'TAILORED_WIDGET.HTML_CONTENT.BACKGROUND_COLOR' | translate">
        <div class="flex-row">
            <input advizeoInput id="backgroundColor" formControlName="backgroundColor" type="color" />
            @if (formGroup.controls.backgroundColor.value) {
                <ui-icon-button iconName="remove" size="small" (click)="clearBgColor()" />
            } @else {
                <div class="no-color" (click)="triggerInput('backgroundColor')">
                    <ui-icon name="none" size="small" />
                </div>
            }
        </div>
    </ui-form-field>

    <ui-form-field [label]="'TAILORED_WIDGET.HTML_CONTENT.VERTICAL_ALIGNMENT' | translate">
        <ui-select
            formControlName="verticalAlignment"
            valueField="code"
            labelField="label"
            [required]="true"
            [options]="options"
            [hideSearch]="true"
        />
    </ui-form-field>

    <shared-ui-wysiwyg formControlName="value" class="grid-span-3" [bgColor]="formGroup.controls.backgroundColor.value" />
</div>
